import React from "react";

import { WEB_V2_SOURCE_SCREENS } from "@vahak/core/dist/constants/event-names";

import { useCompactFlowAppTracker } from "../compact-flow/useCompactFlowAppTracker";
import { CompactLoadBiddingProvider } from "./CompactLoadBiddingProvider";

/**
 * App-level host for the compact load bidding flow.
 *
 * Bidding i18n namespaces are fetched when the modal opens (`loadNamespaces`).
 */
const CompactLoadBiddingAppProvider = ({ children }: React.PropsWithChildren<{}>) => {
    const { trackEvent } = useCompactFlowAppTracker();

    return (
        <CompactLoadBiddingProvider
            trackEvent={trackEvent}
            eventData={{ source_screen: WEB_V2_SOURCE_SCREENS.BID_FORM }}
        >
            {children}
        </CompactLoadBiddingProvider>
    );
};

export default CompactLoadBiddingAppProvider;
